import { useState } from "react";
import { Bell, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatDateHeure } from "@/lib/format";
import { Switch } from "@/components/ui/switch";
import { jouerPop, reglerSonMicro, sonMicroActif } from "@/components/shell/sonMicro";

const SonMicro = () => {
  const [actif, setActif] = useState(sonMicroActif());
  const basculer = (v) => { reglerSonMicro(v); setActif(v); if (v) jouerPop(); };
  return (
    <label className="at-soft p-4 mt-4 min-h-[56px] flex items-center justify-between gap-3 cursor-pointer">
      <span><span className="font-semibold block">Son du micro</span><span className="text-xs at-muted">Petit « pop » quand vous appuyez sur le micro jaune du dock (sur cet appareil)</span></span>
      <Switch checked={actif} onCheckedChange={basculer} className="shrink-0 [&>span]:!bg-[var(--surface)] data-[state=checked]:!bg-[var(--accent)] data-[state=unchecked]:!bg-[var(--muted)]" data-testid="compte-son-micro-switch" />
    </label>
  );
};

const Info = ({ label, valeur, testId }) => (
  <div className="at-soft p-4"><p className="at-label">{label}</p><p className="font-semibold mt-1 break-words" data-testid={testId}>{valeur || "—"}</p></div>
);

async function activerNotifications() {
  if (!("Notification" in window)) return toast.error("Votre navigateur ne gère pas les notifications.");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return toast.error("Notifications refusées par le navigateur.");
  const reg = await navigator.serviceWorker?.getRegistration();
  if (reg) reg.showNotification("Airthermo V2", { body: "Les notifications sont activées sur cet appareil.", icon: "/icon-192.png" });
  toast.success("Notifications activées sur cet appareil.");
}

export default function Compte() {
  const { user, deconnexion } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="at-card p-5 md:p-7">
      <h2 className="text-base md:text-lg font-bold mb-4">Mon compte</h2>
      <div className="grid sm:grid-cols-2 gap-3">
        <Info label="Nom" valeur={`${user.prenom} ${user.nom}`} testId="compte-nom" />
        <Info label="E-mail" valeur={user.email} testId="compte-email" />
        <Info label="Profil" valeur={user.role_label} testId="compte-role" />
        {user.partenaire_nom && <Info label="Société partenaire" valeur={user.partenaire_nom} testId="compte-partenaire" />}
        <Info label="Dernière connexion" valeur={formatDateHeure(user.derniere_connexion)} />
      </div>
      <p className="at-muted text-sm mt-5">Installez l'application : menu du navigateur › « Ajouter à l'écran d'accueil ».</p>
      <SonMicro />
      <div className="flex flex-col sm:flex-row gap-2 mt-4">
        <button type="button" onClick={activerNotifications} className="at-btn at-btn-ghost" data-testid="compte-notifications-button"><Bell size={17} />Activer les notifications</button>
        <button type="button" onClick={async () => { await deconnexion(); navigate("/connexion"); }} className="at-btn at-btn-primary" data-testid="compte-logout-button"><LogOut size={17} />Se déconnecter</button>
      </div>
    </div>
  );
}
